import type { ZionThemeId } from '../ui/themes.ts'

const STORAGE_KEY = 'zion-theme'

function normalizeThemeId(raw: string | null | undefined): ZionThemeId {
  const id = String(raw ?? '')
    .trim()
    .toLowerCase()
  if (id === 'matrix') return 'matrix'
  if (
    id === 'white_platinum' ||
    id === 'minimal_white_platinum' ||
    id === 'white-platinum' ||
    id === 'arctic_light' ||
    id === 'glacial_white'
  ) {
    return 'white_platinum'
  }
  return 'default'
}

/** Tema salvato; default = Minimal Void & Cobalt. */
export function getStoredTheme(): ZionThemeId {
  try {
    return normalizeThemeId(localStorage.getItem(STORAGE_KEY))
  } catch {
    return 'default'
  }
}

export function saveTheme(theme: ZionThemeId): void {
  try {
    localStorage.setItem(STORAGE_KEY, normalizeThemeId(theme))
  } catch {
    /* ignore */
  }
}
